import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Divider from '@material-ui/core/Divider'
import DialogTitle from '@material-ui/core/DialogTitle'
import WorkExperienceForm from '../../../WorkExperience/Form'
import { StyledActions, StyledContent } from '../styles'
import { useOnboarding } from '../../../../../contexts/OnboardingContext'
import { DialogContentText } from '@material-ui/core'

export default function WorkExperienceDialog(props) {
  const { open, handleClose, initialValues, setPropChange } = props
  const { formRef } = useOnboarding()

  const updateForm = async () => {
    await formRef.current.handleSubmit()
    setPropChange(true)
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>Work Experience</DialogTitle>
      <DialogContentText>
        Please add all relevant work experience. This information will build your Paro profile and help determine if
        your expertise is a good fit for the Paro network. Be sure to include all relevant tags for industry, software,
        and skills. Tags are especially important to define your true expertise at the end of registration and for
        matching you to projects once fully onboarded to the platform!
      </DialogContentText>
      <StyledContent>
        <WorkExperienceForm initialValues={initialValues} profileReviewDialog={true} />
      </StyledContent>
      <Divider />
      <StyledActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={updateForm} color="primary">
          Save
        </Button>
      </StyledActions>
    </Dialog>
  )
}
